import { Divider, Drawer, Typography } from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { PermissionInfo } from "../../../../context";
import moment from "moment";

const PrintWith58MMPrinter = ({
  open,
  close,
  data,
  totalCost,
  totalDiscount,
  totalPerProd,
  description,
  hasCostPerProd,
}) => {
  // console.log("data: ", data);
  const componentRef = useRef();
  // const [paddingPrint, setPaddingPrint] = useState(0);
  const { permissionList } = useContext(PermissionInfo);

  //   console.log("permissionList: ", permissionList.data.merchant_info);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        // setPaddingPrint(10);
        resolve();
      });
    },
    onAfterPrint: () => {
      // setPaddingPrint(0);
    },
  });

  useEffect(() => {
    handlePrint();
  }, []);

  return (
    <Drawer
      title="Order Receipt"
      width={window.innerWidth > 500 ? 500 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
        display: "flex",
        justifyContent: "center",
        // alignItems: "center",
      }}
    >
      <div
        ref={componentRef}
        className="print-wrapper"
        style={{
          // border: "1px solid red",
          paddingRight: 13,
          paddingLeft: 0,
          margin: 0,
          // padding: 0,
        }}
      >
        <p
          style={{
            textAlign: "center",
            textTransform: "uppercase",
            fontSize: 16,
            // transform: "scale(1, 1.5)",
            // fontFamily: "inherit",
            fontFamily: "ChivoMono",
            // fontWeight: "bold",
            // marginBottom: 10,
          }}
          // className="print-text-center"
        >
          {permissionList.data.merchant_info.business_name}
        </p>
        <p
          style={{
            textAlign: "center",
            textTransform: "uppercase",
            // transform: "scale(1, 1.1)",
            fontSize: 10,
            // fontFamily: "inherit",
            fontFamily: "ChivoMono",
            // fontWeight: "bold",
          }}
        >
          {permissionList.data.merchant_info.business_street},{" "}
          {permissionList.data.merchant_info.business_barangay},{" "}
          {permissionList.data.merchant_info.business_city},{" "}
          {permissionList.data.merchant_info.business_province}
        </p>
        <div className="hidewhenprint">
          <Divider />
        </div>
        <div className="showwhenprint">--------------------------</div>
        <p
          style={{
            // transform: "scale(1, 1.5)",
            fontSize: 10,
            // fontFamily: "inherit",
            fontFamily: "ChivoMono",
            // fontWeight: "bold",
          }}
        >
          Transaction No.: {data.length > 0 && data[0].transaction_id}
        </p>
        <p
          style={{
            // transform: "scale(1, 1.5)",
            fontSize: 10,
            // fontFamily: "inherit",
            fontFamily: "ChivoMono",
            // fontWeight: "bold",
          }}
        >
          Date.:{" "}
          {moment
            .utc(data.length > 0 && data[0].created_at)
            .format("MMM. DD, YYYY")}
        </p>
        <div className="hidewhenprint">
          <Divider />
        </div>
        <div className="showwhenprint">--------------------------</div>
        <div
          style={{
            display: "flex",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "10%",
              // transform: "scale(1, 1.5)",
              fontSize: 10,
              // fontFamily: "inherit",
              fontFamily: "ChivoMono",
              // fontWeight: "bold",
            }}
          >
            QTY
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "46%",
              // transform: "scale(1, 1.5)",
              fontSize: 10,
              // fontFamily: "inherit",
              fontFamily: "ChivoMono",
              // fontWeight: "bold",
            }}
          >
            DESC
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "22%",
              // transform: "scale(1, 1.5)",
              fontSize: 10,
              // fontFamily: "inherit",
              fontFamily: "ChivoMono",
              // fontWeight: "bold",
            }}
          >
            PRICE
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              width: "22%",
              // transform: "scale(1, 1.5)",
              fontSize: 10,
              // fontFamily: "inherit",
              fontFamily: "ChivoMono",
              // fontWeight: "bold",
            }}
          >
            TOTAL
          </div>
        </div>
        <div className="hidewhenprint">
          <Divider />
        </div>
        <div className="showwhenprint">--------------------------</div>
        {data.length > 0 &&
          data.map((item, index) => (
            <div
              style={{
                display: "flex",
                width: "100%",
                marginTop: index === 0 ? 10 : 0,
                marginBottom: data.length === index + 1 ? 0 : 20,
              }}
              key={index}
            >
              <div
                style={{
                  display: "flex",
                  width: "10%",
                  alignItems: "center",
                }}
              >
                {parseFloat(item.is_per_piece) === 1 ? (
                  <p
                    style={{
                      // transform: "scale(1, 1.5)",
                      fontSize: 9,
                      // fontFamily: "inherit",
                      fontFamily: "ChivoMono",
                      // fontWeight: "bold",
                    }}
                  >
                    {item.quantity}
                  </p>
                ) : (
                  <p
                    style={{
                      // transform: "scale(1, 1.5)",
                      fontSize: 9,
                      // fontFamily: "inherit",
                      fontFamily: "ChivoMono",
                      // fontWeight: "bold",
                    }}
                  >
                    1
                  </p>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  width: "46%",
                  alignItems: "center",
                }}
              >
                {parseFloat(item.is_per_piece) === 1 ? (
                  <p
                    style={{
                      // transform: "scale(1, 1.5)",
                      fontSize: 10,
                      // fontFamily: "inherit",
                      fontFamily: "ChivoMono",
                      // fontWeight: "bold",
                    }}
                  >
                    {item.product}
                  </p>
                ) : (
                  <p
                    style={{
                      // transform: "scale(1, 1.5)",
                      fontSize: 9,
                      // fontFamily: "inherit",
                      fontFamily: "ChivoMono",
                      // fontWeight: "bold",
                    }}
                  >
                    {item.product} - {item.quantity}gram(s)
                  </p>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  width: "22%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    // transform: "scale(1, 2)",
                    fontSize: 9,
                    // fontFamily: "inherit",
                    fontFamily: "ChivoMono",
                    // fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {item.price}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  width: "22%",
                  justifyContent: "end",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                {parseFloat(item.is_per_piece) === 1 ? (
                  <p
                    style={{
                      // transform: "scale(1, 2)",
                      fontSize: 9,
                      // fontFamily: "inherit",
                      fontFamily: "ChivoMono",
                      // fontWeight: "bold",
                    }}
                  >
                    {parseFloat(
                      parseFloat(item.price) * parseFloat(item.quantity),
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                ) : (
                  <p
                    style={{
                      // transform: "scale(1, 2)",
                      fontSize: 9,
                      // fontFamily: "inherit",
                      fontFamily: "ChivoMono",
                      // fontWeight: "bold",
                    }}
                  >
                    {item.price}
                  </p>
                )}
              </div>
            </div>
          ))}
        <div className="hidewhenprint">
          <Divider />
        </div>
        <div className="showwhenprint">--------------------------</div>
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }}>
            <p
              style={{
                // transform: "scale(1, 1.5)",
                fontSize: 10,
                // fontFamily: "inherit",
                fontFamily: "ChivoMono",
                // fontWeight: "bold",
              }}
            >
              Gross Sales:
            </p>
          </div>
          <p
            style={{
              // transform: "scale(1, 1.5)",
              fontSize: 10,
              // fontFamily: "inherit",
              fontFamily: "ChivoMono",
              // fontWeight: "bold",
            }}
          >
            {totalCost.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        </div>
        {hasCostPerProd && (
          <div style={{ display: "flex" }}>
            <div style={{ flexGrow: 1 }}>
              <p
                style={{
                  // transform: "scale(1, 1.5)",
                  fontSize: 10,
                  // fontFamily: "inherit",
                  fontFamily: "ChivoMono",
                  // fontWeight: "bold",
                }}
              >
                Total {description}:
              </p>
            </div>
            <p
              style={{
                // transform: "scale(1, 1.5)",
                fontSize: 10,
                // fontFamily: "inherit",
                fontFamily: "ChivoMono",
                // fontWeight: "bold",
              }}
            >
              {totalPerProd.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
        )}
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }}>
            <p
              style={{
                // transform: "scale(1, 1.5)",
                fontSize: 10,
                // fontFamily: "inherit",
                fontFamily: "ChivoMono",
                // fontWeight: "bold",
              }}
            >
              Total Discount:
            </p>
          </div>
          <p
            style={{
              // transform: "scale(1, 1.5)",
              fontSize: 10,
              // fontFamily: "inherit",
              fontFamily: "ChivoMono",
              // fontWeight: "bold",
            }}
          >
            {totalDiscount.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        </div>
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ flexGrow: 1 }}>
            <p
              style={{
                // transform: "scale(1, 1.5)",
                fontSize: 10,
                // fontFamily: "inherit",
                fontFamily: "ChivoMono",
                // fontWeight: "bold",
              }}
            >
              Net Sales:
            </p>
          </div>
          <p
            style={{
              // transform: "scale(1, 1.5)",
              fontSize: 10,
              // fontFamily: "inherit",
              fontFamily: "ChivoMono",
              // fontWeight: "bold",
            }}
          >
            {parseFloat(
              totalCost + totalPerProd - totalDiscount,
            ).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        </div>
        <div className="hidewhenprint">
          <Divider />
        </div>
        <div className="showwhenprint">--------------------------</div>
        <p
          style={{
            // transform: "scale(1, 1.5)",
            fontSize: 12,
            // fontFamily: "inherit",
            fontFamily: "ChivoMono",
            // fontWeight: "bold",
            textAlign: "center",
          }}
        >
          Thank you for dining with us.
        </p>
      </div>
    </Drawer>
  );
};

export default PrintWith58MMPrinter;
